import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const AnouncementIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "AnouncementIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        d="M5.76601 18.2883C4.58978 18.2883 3.44453 17.6786 2.81463 16.5889C1.87739 14.9652 2.43551 12.8812 4.0597 11.943L6.56901 10.4944C6.80799 10.3528 7.11729 10.4373 7.25695 10.6783L10.1547 15.6969C10.2216 15.813 10.2393 15.9497 10.2049 16.0795C10.1705 16.2083 10.0859 16.3185 9.97033 16.3843L7.46102 17.833C6.927 18.1418 6.34282 18.2883 5.76601 18.2883ZM6.63638 11.6175L4.56323 12.8144C3.41996 13.4753 3.02706 14.9426 3.68696 16.0854C4.34686 17.2272 5.81322 17.6186 6.95748 16.9617L9.03062 15.7648L6.63638 11.6175Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.71905 16.4522C9.54448 16.4522 9.37532 16.3617 9.28239 16.2004L6.38461 11.1818C6.24594 10.9409 6.32806 10.633 6.56901 10.4944C6.58524 10.4845 8.19861 9.54532 9.05227 8.51465C9.92018 7.46529 11.0512 4.88468 11.0625 4.85812C11.0807 4.8178 11.1033 4.77945 11.1313 4.74503C11.3983 4.41164 11.8158 4.24149 12.2367 4.26411C12.6626 4.29657 13.0437 4.53653 13.2576 4.90632L18.1538 13.3868C18.3672 13.7565 18.3839 14.207 18.199 14.5915C18.0141 14.976 17.6522 15.2445 17.2303 15.3084C17.188 15.3153 17.1457 15.3163 17.1024 15.3114C17.0739 15.3084 14.2661 15.0193 13.0801 15.2012C11.9107 15.3802 9.97083 16.3853 9.95117 16.3952C9.87692 16.4335 9.79724 16.4522 9.71905 16.4522ZM7.50133 11.1012L9.9182 15.2868C10.6017 14.9583 11.9495 14.3555 12.9276 14.206C14.1378 14.0211 16.6353 14.2542 17.126 14.3014C17.2268 14.2689 17.2745 14.1912 17.2912 14.1558C17.3109 14.1145 17.3493 14.0073 17.2814 13.8903L12.3852 5.40985C12.3179 5.29282 12.2057 5.27217 12.1605 5.26922C12.1192 5.25938 12.0302 5.26725 11.952 5.33806C11.7479 5.79636 10.7069 8.09373 9.8282 9.15588C9.14321 9.98396 8.08797 10.7235 7.50133 11.1012Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.6125 21.8937C10.4562 21.8937 10.2988 21.8731 10.1439 21.8318C9.67873 21.7069 9.28977 21.4089 9.04932 20.9919L7.03272 17.4996C6.89356 17.2587 6.97617 16.9508 7.21712 16.8122L9.46681 15.513C9.58237 15.4451 9.71956 15.4284 9.84888 15.4619C9.97771 15.4973 10.0879 15.5809 10.1547 15.6969L12.1708 19.1892C12.4118 19.6062 12.4757 20.092 12.3513 20.5572C12.2264 21.0224 11.9284 21.4109 11.5114 21.6508C11.2336 21.8121 10.9248 21.8937 10.6125 21.8937ZM8.15681 17.4317L9.92164 20.4884C10.0279 20.6723 10.199 20.8041 10.404 20.8591C10.6106 20.9132 10.824 20.8867 11.0079 20.7795L11.0084 20.7785C11.1918 20.6733 11.3236 20.5021 11.3782 20.2966C11.4332 20.091 11.4052 19.8766 11.2985 19.6927L9.53416 16.6361L8.15681 17.4317Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.235 11.5752C16.1912 11.5752 16.1475 11.5693 16.1047 11.5585C15.9759 11.5231 15.8657 11.4395 15.7988 11.3234L13.8673 7.97768C13.7286 7.73673 13.8108 7.42891 14.0517 7.29023C14.6143 6.96372 15.2702 6.87816 15.8997 7.04633C16.5276 7.2145 17.0528 7.61772 17.3783 8.18125C18.0495 9.34371 17.6497 10.8356 16.4868 11.5073C16.4096 11.5526 16.3225 11.5752 16.235 11.5752ZM15.0367 7.9885L16.3732 10.3046C16.739 9.85708 16.8113 9.21292 16.506 8.68479C16.3152 8.35435 16.0073 8.11733 15.639 8.01899C15.4394 7.9649 15.2358 7.95506 15.0367 7.9885Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.0792 7.70232C18.9051 7.70232 18.736 7.61184 18.6425 7.45055C18.5034 7.2096 18.586 6.90178 18.8269 6.7631L20.5333 5.77865C20.7727 5.63704 21.082 5.72161 21.2212 5.96256C21.3604 6.20351 21.2777 6.51133 21.0368 6.65001L19.3305 7.63446C19.2513 7.68068 19.1648 7.70232 19.0792 7.70232Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.5489 5.75505C17.4693 5.75505 17.3886 5.73636 17.3134 5.69604C17.0675 5.56622 16.9741 5.26135 17.1049 5.01548L17.9762 3.37408C18.1061 3.1292 18.4109 3.0338 18.6568 3.16559C18.9027 3.29541 18.9961 3.60028 18.8653 3.84615L17.9939 5.48755C17.9039 5.65769 17.7294 5.75505 17.5489 5.75505Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.857 10.0675H21.8388L19.982 10.0017C19.7037 9.99182 19.4868 9.75775 19.4967 9.48042C19.5065 9.20112 19.7676 8.97492 20.0174 8.99459L21.8742 9.06048C22.1525 9.07032 22.3694 9.30438 22.3595 9.58172C22.3502 9.85414 22.1265 10.0675 21.857 10.0675Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default AnouncementIcon;
